/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { StateCreator } from 'zustand';

export interface MenuSlice {
  menuOpen: boolean;
  setMenuOpen: (menuOpen: boolean) => void;
}

export const createMenuSlice: StateCreator<MenuSlice, [], [], MenuSlice> = (set) => ({
  menuOpen: false,
  setMenuOpen: (menuOpen: boolean) =>
    set(() => ({
      menuOpen,
    })),
});
